module.exports = "<ui-view></ui-view>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sepa/template.html
// module id = ./pages/xo-sepa/template.html
// module chunks = 0